import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    byKey: {},
};

const retainerStatusSlice = createSlice({
    name: "retainerStatus",
    initialState,
    reducers: {
        setRetainerStatus: (state, { payload: { key, status } }) => {
            state.byKey[key] = status;
        },
    },
});

export const { setRetainerStatus } = retainerStatusSlice.actions;
export default retainerStatusSlice.reducer;
